import { cn } from "@/lib/helpers/cn";
import type { HTMLAttributes } from "react";

export function Divider2({ className, ...hrProps }: HTMLAttributes<HTMLHRElement>) {
  return (
    <hr
      className={cn("tw:h-px! tw:border-0! tw:my-0! tw:bg-stroke-quaternary", className)}
      {...hrProps}
    />
  );
}
